import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function Classes() {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    api.get("/courses").then((r) => setCourses(r.data)).catch(() => {});
  }, []);

  return (
    <main data-testid="classes-page" className="bg-[#0D0C0A] min-h-screen pt-32 pb-24 px-6 md:px-12">
      <div className="max-w-[1400px] mx-auto">
        <p className="label-eyebrow mb-5">The Curriculum</p>
        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.95] mb-6 max-w-3xl">
          All classes, from <span className="italic text-[#D4AF37]">first turn</span> to final firing.
        </h1>
        <p className="text-[#D5D0C5] max-w-2xl mb-20 text-lg leading-relaxed">
          Enroll in any class. Progress saves automatically, and every lesson comes with Marilyn at the end of a message.
        </p>

        <div className="space-y-6">
          {courses.map((c, i) => (
            <Link
              key={c.id}
              to={`/classes/${c.id}`}
              data-testid={`class-row-${c.id}`}
              className="group grid md:grid-cols-12 gap-8 border-t border-[#332D29] pt-10 pb-10 hover:border-[#D4AF37]/40 transition-colors"
            >
              <div className="md:col-span-4 aspect-[4/3] md:aspect-auto overflow-hidden">
                <img src={c.cover} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="md:col-span-7 flex flex-col justify-between">
                <div>
                  <p className="label-eyebrow mb-4">0{i+1} · {c.level} · {c.duration}</p>
                  <h2 className="font-display text-4xl sm:text-5xl mb-4 group-hover:text-[#D4AF37] transition-colors">{c.title}</h2>
                  <p className="text-[#D4AF37]/80 italic text-lg mb-4">{c.tagline}</p>
                  <p className="text-[#D5D0C5] leading-relaxed max-w-xl">{c.description}</p>
                </div>
                <div className="mt-8 flex items-center gap-6">
                  <span className="text-xs tracking-[0.3em] uppercase text-[#B3AFA8]">{c.lesson_count} lessons</span>
                  <span className="text-[#D4AF37] text-sm inline-flex items-center gap-2">
                    Enter <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </main>
  );
}
